import { PermissionsEnum } from '@/auth/interfaces/permissions.enum';
import { useAuthStore } from '@/store/auth/auth.store';
import { useUserPermissionsStore } from '@/store/auth/user-permissions.store';

const isSuperUser = (): boolean => {
  const user = useAuthStore.getState().user as any;
  return !!(user?.is_superuser || user?.is_staff);
};

export const hasPermission = (permission: PermissionsEnum): boolean => {
  if (isSuperUser()) return true;
  const userPermissions = useUserPermissionsStore.getState().permissions;
  return userPermissions.includes(permission);
};

export const hasAllPermissions = (permissions: PermissionsEnum[]): boolean => {
  if (isSuperUser()) return true;
  const userPermissions = useUserPermissionsStore.getState().permissions;

  return permissions.every(permission => userPermissions.includes(permission));
};
